export enum PRODUCT_STATUS {
  NUEVO = 0,
  REFURBISHED = 1,
}

export const ProductStatusStrings: Record<PRODUCT_STATUS, string> = {
  [PRODUCT_STATUS.NUEVO]: 'Nuevo',
  [PRODUCT_STATUS.REFURBISHED]: 'Refurbished',
};
